import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AlertController, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-selectuser',
  templateUrl: './selectuser.page.html',
  styleUrls: ['./selectuser.page.scss'],
})
export class SelectuserPage implements OnInit {
  myform: FormGroup;
  constructor(private fireStore: AngularFirestore, private formBuilder: FormBuilder, public alertController: AlertController, public modalC: ModalController) {


  }
  utenti = [];
  @Input() id;
  @Input() nome;
  @Input() data
  @Input() n_bersagli
  @Input() user_id;
  @Input() user_invited;
  @Input() admin;
  @Input() type;

  showadmin: boolean = false;
  show_admin() {
    if (this.showadmin == true)
      this.showadmin = false;
    else
      this.showadmin = true;
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    //console.logthis.user_invited);
    //console.logthis.user_id);
    if(this.type == 'ranking')
       this.showadmin = true;
    this.fireStore.collection<any>('userProfile').snapshotChanges().subscribe(actions => {

      let objform = {};
      this.utenti = actions.map((el: any, index) => {
        let data = el.payload.doc.data();
        // //console.logdata);
        return data;
      }).filter(ele => { return ele.uid !== this.user_id }).map((elem, index) => { 
        // //console.logelem);

        if (this.user_invited.indexOf(elem.uid) != -1)
          objform[elem.uid] = new FormControl(true);
        else
          objform[elem.uid] = new FormControl(false);

        return elem;
      }).sort(function (a, b) {

        var nameA = a.cognome.toUpperCase() + a.nome.toUpperCase(); // ignora maiuscole e minuscole
        var nameB = b.cognome.toUpperCase() + b.nome.toUpperCase(); // ignora maiuscole e minuscole
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })
      // setTimeout(() => {
      //console.logthis.utenti);
      this.myform = new FormGroup(objform);

      // }, 6000);


      // this.form = this.formBuilder.group({

      // });

    })


  }
  change(ev) {

  }
  invita() {
    var arr_invitati = [];
    //console.logthis.myform.value);
    for (let a in this.myform.value) {
      if (this.myform.value[a] == true)
        arr_invitati.push(a);
    }

    //console.logarr_invitati);


    // this.utenti.map(el => {
    //   if (el.isChecked == true) {
    //     arr_invitati.push(el.id);
    //   }
    //   return el;
    // });
    // //console.logarr_invitati);
    this.fireStore.collection<any>('gara').doc(this.id).update({ user_invited: arr_invitati }).then(() => {

      this.presentAlert();
      this.modalC.dismiss();
    })
  }
  close() {
    this.modalC.dismiss();
  }
  async presentAlert() {
    let obj_alert = {
      header: 'Inviti',
      subHeader: 'Gara',
      message: 'Gli inviti sono stati salvati con successo',
      buttons: ['OK']
    }
    const alert = await this.alertController.create(obj_alert);

    await alert.present();
  }




  async set_admin(user) {
    const alert = await this.alertController.create({
      header: 'Aggiungi Amministratore',
      message: 'Sei sicuro di voler <strong>aggiungere</strong> come amministratore ' + user.cognome + ' ' + user.nome + '?',
      buttons: [
        {
          text: 'Annulla',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {

          }
        }, {
          text: 'Si, aggiungi',
          handler: () => {
            this.admin.push(user.uid);
            this.fireStore.collection<any>('gara').doc(this.id).update({ admin: this.admin }).then(() => {

              // this.presentAlert();
              this.modalC.dismiss();
            })
          }
        }
      ]
    });

    await alert.present();
  }

  async del_admin(user) {
    const alert = await this.alertController.create({
      header: 'Aggiungi Amministratore',
      message: 'Sei sicuro di voler <strong>eliminare</strong> come amministratore ' + user.cognome + ' ' + user.nome + '?',
      buttons: [
        {
          text: 'Annulla',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {

          }
        }, {
          text: 'Si, rimuovi',
          handler: () => {
            

            const index = this.admin.indexOf(user.uid);
            if (index > -1) {
              this.admin.splice(index, 1);
            }
            this.fireStore.collection<any>('gara').doc(this.id).update({ admin: this.admin }).then(() => {

              // this.presentAlert();
              // this.modalC.dismiss();
            })
          }
        }
      ]
    });

    await alert.present();
  }
}
